import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH3 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <Typography element="h3" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH3.displayName = 'RichTextH3';

export default RichTextH3;
